/** @jsxImportSource @emotion/react */
import { css, Theme, useTheme } from '@emotion/react'
import { FC, ReactNode } from 'react'
import { RpBreakpoints, useRpBreakpoint } from '../../core/theme'

export interface IconWrapperProps {
  size?: string | Record<RpBreakpoints, string>
  color?: keyof Theme['rpTheme']['colors']
  opacity?: number
  className?: string
  children?: ReactNode
}

const IconWrapper: FC<IconWrapperProps> = (props) => {
  const { children, opacity, className, color, size } = props

  const theme = useTheme() as Theme
  const breakpoint = useRpBreakpoint()

  const dimension =
    typeof size === 'string'
      ? size
      : size?.[breakpoint] ??
        size?.mobile ??
        size?.tablet ??
        size?.desktop ??
        '10px'

  const styles = css`
    color: ${color ? theme.rpTheme.colors[color] : theme.rpTheme.colors.white};
    display: inline-flex;
    align-items: center;
    width: ${dimension};
    justify-content: center;
    line-height: 1;

    & > svg {
      width: 100%;
      height: 100%;
      fill: currentColor;
      opacity: ${opacity || 1};
    }
  `

  return (
    <span className={className} css={styles}>
      {children}
    </span>
  )
}

export default IconWrapper
